/// <amd-module name="Artifacts/Feed/redux/Module" />

import {
  IArtifactsSettingsPanelState,
  ICreateFeedPanelState,
  IFeedHubState,
} from "Artifacts/Feed/redux/Contracts";
import {
  artifactsSettingsPanelReducer,
  createFeedPanelReducer,
  feedHubReducer,
} from "Artifacts/Feed/redux/Reducer";
import rootSaga from "Artifacts/Feed/redux/Sagas";
import { FeedPickerModule } from "Artifacts/FeedPicker/redux";
import { combineReducers } from "redux";
import { ISagaModule } from "redux-dynamic-modules-saga";

export interface IFeedModuleState {
  // This layer is so IFeedState isn't in redux store root with other modules
  feed: IFeedState;
}

interface IFeedState {
  hub: IFeedHubState;
  createFeedPanel: ICreateFeedPanelState;
  artifactsSettingsPanel: IArtifactsSettingsPanelState;
}

const _feedModule: ISagaModule<IFeedModuleState> = {
  id: "feed",
  reducerMap: {
    feed: combineReducers({
      hub: feedHubReducer,
      createFeedPanel: createFeedPanelReducer,
      artifactsSettingsPanel: artifactsSettingsPanelReducer,
    }),
  },
  sagas: [rootSaga],
};

export const FeedModule = [_feedModule, FeedPickerModule];
